import { t } from "i18next";

export const forgotPasswordFormLogic = {
    formFields: ['email'],
    email: {
        id:"email",
        className: "",
        value: '',
        name: 'email',
        type: 'email',
        label: t('sign_up.email_address'),
        required: true,
        maxLength: 50,
        dangerWarn: false,
        errorMessage: null,
        regex: "^(?!\\.)(?!.*\\.\\.)(?!.*\\.@)[a-zA-Z0-9.!#$%&'*+\\-/=?^_`{|}~]+@(?!\\-)[a-zA-Z0-9.-]*[a-zA-Z0-9]\\.(?!\\-)[a-zA-Z0-9-]+[a-zA-Z0-9]$"
    }
}